import { cssVars } from '@/app/styles';
import styled from 'styled-components';

export const HelpTabsContentWrapper = styled.div`
  overflow-y: scroll;
  margin-left: 110px;
  height: 100%;
  color: ${cssVars.textColors.dark3};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InnerWrapper = styled.div`
  margin: 21px 30px 21px 0px;
`;

export const GlossaryWrapper = styled.div`
  margin: 21px 30px 21px 0px;
  display: flex;
  flex-direction: column;
`;

export const GlossaryImg = styled.img`
  object-fit: contain;
  border-radius: 4.4px;
  margin: 8px;
`;

export const Header = styled.div`
  font-size: 18px;
  font-weight: 600;
`;

export const Description = styled.p`
  width: 860px;
  margin-top: 10px;
  font-size: 14px;
  color: ${cssVars.textColors.dark2};
`;

export const FeaturesContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 900px;
  margin-left: 0px;
  padding-left: 0px;
`;

export const StyledNavButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 400px;
  height: 400px;
  margin: auto;
  cursor: pointer;
  :hover {
    transform: scale(1.1);
    & > p {
      color: ${cssVars.color.rentalscapeBlue};
    }
  }
`;

export const StyledImg = styled.img`
  height: 300px;
  width: 380px;
`;

export const NavButtonHeader = styled.div`
  font-size: 18px;
  font-weight: 600px;
  color: ${cssVars.color.helpPageColor.textColor};
`;

export const NavButtonCaption = styled.div`
  line-height: 1.57;
  font-family: Lato;
`;

export const FeatureImage = styled.img`
  height: 200px;
  object-fit: contain;
  border-radius: 4.4px;
  margin: 8px 0px;
`;

export const FeatureWrapper = styled.div`
  flex-direction: row;
  flex-wrap: wrap;
`;

export const FeaturesInnerWrapper = styled.div`
  margin-top: 42px;
  margin-right: 100px;
`;
